import { calcDetailPath } from '@utils/constants.js'

export interface CalcSearchHit {
  id: string
  kind: 'ferramenta'
  title: string
  meta: string
  path: string
}

interface CalcItem {
  id: string
  title: string
  desc: string
  modulo: string
}

const ITEMS: CalcItem[] = [
  {
    id: 'topografia',
    title: 'Diagnóstico de Topografia',
    desc: 'Talude e custo',
    modulo: 'Terreno',
  },
  { id: 'corte-aterro', title: 'Corte e Aterro', desc: 'Volume de terra', modulo: 'Terreno' },
  { id: 'insolacao', title: 'Análise de Insolação', desc: 'Orientação solar', modulo: 'Terreno' },
  { id: 'sondagem', title: 'Custo de Sondagem SPT', desc: 'Perfil do solo', modulo: 'Terreno' },
  {
    id: 'sistemas',
    title: 'Comparador de Sistemas',
    desc: 'Alvenaria, steel frame',
    modulo: 'Sistemas',
  },
  { id: 'espessura', title: 'Espessura de Parede', desc: 'Área útil', modulo: 'Sistemas' },
  { id: 'vaos', title: 'Vãos Livres', desc: 'Vigas por vão', modulo: 'Sistemas' },
  { id: 'casca', title: 'Fator Casca', desc: 'Eficiência geométrica', modulo: 'Projetos' },
  { id: 'comodo', title: 'Custo por Cômodo', desc: 'Heatmap m²', modulo: 'Projetos' },
  { id: 'otimizador', title: 'Otimizador de Áreas', desc: 'Distribuição', modulo: 'Projetos' },
  { id: 'aberturas', title: 'Aberturas/Esquadrias', desc: 'Vidro na fachada', modulo: 'Projetos' },
  { id: 'pe-direito', title: 'Pé-direito', desc: 'Altura vs custo', modulo: 'Projetos' },
  {
    id: 'viabilidade',
    title: 'Simulador de Viabilidade',
    desc: 'Orçamento por fase',
    modulo: 'Financeiro',
  },
  { id: 'curva-s', title: 'Curva S de Desembolso', desc: 'Fluxo mensal', modulo: 'Financeiro' },
  { id: 'reserva', title: 'Reserva de Contingência', desc: 'Imprevistos', modulo: 'Financeiro' },
  { id: 'financiamento', title: 'Financiamento', desc: 'SAC × PRICE', modulo: 'Financeiro' },
  { id: 'inflacao', title: 'Inflação vs Cronograma', desc: 'INCC', modulo: 'Financeiro' },
  { id: 'contratacao', title: 'Tipos de Contratação', desc: 'Empreitada', modulo: 'Mão de obra' },
  { id: 'equipe', title: 'Equipe Ideal', desc: 'Composição por fase', modulo: 'Mão de obra' },
  { id: 'pedreiro', title: 'Custo do Pedreiro', desc: 'Diária vs mensal', modulo: 'Mão de obra' },
  { id: 'aditivos', title: 'Detector de Aditivos', desc: 'Red flags', modulo: 'Mão de obra' },
  { id: 'impostos', title: 'Impostos Totais', desc: 'ITBI INSS IPTU', modulo: 'Tributos' },
  { id: 'inss', title: 'INSS de Obra', desc: 'Por contratação', modulo: 'Tributos' },
  { id: 'cno', title: 'Alerta de CNO', desc: '30 dias alvará', modulo: 'Tributos' },
  { id: 'habitese', title: 'Habite-se', desc: 'Regularização', modulo: 'Tributos' },
  {
    id: 'cronograma',
    title: 'Cronograma Físico-Financeiro',
    desc: 'Gantt fases',
    modulo: 'Execução',
  },
  { id: 'atrasos', title: 'Detector de Atrasos', desc: 'Plano vs real', modulo: 'Execução' },
  { id: 'manta-telhado', title: 'Manta vs Telhado', desc: 'Coberturas', modulo: 'Execução' },
]

export const CALC_GRUPOS_FLAT: CalcSearchHit[] = ITEMS.map((item) => {
  const path = calcDetailPath(item.id)
  return {
    id: `calc-${item.id}`,
    kind: 'ferramenta' as const,
    title: item.title,
    meta: `${item.modulo} · ${item.desc}`,
    path,
  }
})
